import React, { useContext } from 'react';

import noop from 'lodash/noop';

import { Issue, ProjectSelectOption } from '@qality/common-model';

export interface AddTestCasesContextProps {
  returnURL: string;
  addTestCasesToTestCycle: (
    selectedIssues: Array<string>,
    testCycleId: number
  ) => void;
  isAddingTestCases: boolean;
  availableIssues: Array<Issue>;
  isFetchingIssues: boolean;
  addingTestCasesLength: number;
  availableProjects: Array<ProjectSelectOption>;
}

const initialValues: AddTestCasesContextProps = {
  returnURL: null,
  addTestCasesToTestCycle: () => noop(),
  isAddingTestCases: false,
  availableIssues: null,
  isFetchingIssues: true,
  addingTestCasesLength: 0,
  availableProjects: [],
};

export const AddTestCasesContext =
  React.createContext<AddTestCasesContextProps>(initialValues);

export const useAddTestCasesContext = (): AddTestCasesContextProps => {
  const value = useContext(AddTestCasesContext);

  if (!value) {
    throw new Error('AddTestCasesContext used outside the provider!');
  }

  return value;
};
